export enum MailboxFeatures {
  MAILS_SEND = 'MAILS_SEND',
  MAILS_RECEIVE = 'MAILS_RECEIVE',
  CALENDAR_INVITE_SEND = 'CALENDAR_INVITE_SEND',
  CALENDAR_INVITE_ACKNOWLEDGE = 'CALENDAR_INVITE_ACKNOWLEDGE',
  ONLINE_MEETING_TEAMS_CREATE = 'ONLINE_MEETING_TEAMS_CREATE',
  READ_WRITE_CONTACTS = 'READ_WRITE_CONTACTS',
}
